(function() {
  'use strict';

  var STORAGE_KEY = 'fc_product_gate_allowed_v2';

  function getGlobalSettings() {
    var g = window.fcGateSettings || {};
    return {
      fcReferrerDomain: g.fcReferrerDomain || 'https://matsuri-fc.com/',
      fcMemberParamName: g.fcMemberParamName || 'fcmember',
      fcMemberParamValue: g.fcMemberParamValue || 'xzuyf2w4m9',
      allowTtlMinutes: parseInt(g.allowTtlMinutes || 1440, 10)
    };
  }

  function checkReferrer(fcReferrerDomain) {
    var referrer = document.referrer;
    if (!referrer) return false;
    return referrer.startsWith(fcReferrerDomain);
  }

  function checkUrlParam(paramName, paramValue) {
    var params = new URLSearchParams(window.location.search);
    return params.get(paramName) === paramValue;
  }

  function isAllowedFromStorage(allowTtlMinutes) {
    try {
      var stored = localStorage.getItem(STORAGE_KEY);
      if (!stored) return false;
      var data = JSON.parse(stored);
      var now = Date.now();
      if (now - data.timestamp < allowTtlMinutes * 60 * 1000) return true;
      localStorage.removeItem(STORAGE_KEY);
      return false;
    } catch (e) {
      return false;
    }
  }

  function saveAllowedState(allowTtlMinutes) {
    try {
      var data = { timestamp: Date.now(), ttlMinutes: allowTtlMinutes };
      localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
    } catch (e) {}
  }

  function runGlobalAllowCheck() {
    var s = getGlobalSettings();
    if (isAllowedFromStorage(s.allowTtlMinutes)) return;
    if (checkReferrer(s.fcReferrerDomain) && checkUrlParam(s.fcMemberParamName, s.fcMemberParamValue)) {
      saveAllowedState(s.allowTtlMinutes);
    }
  }

  function getSubmitLabelSpan(submitButton) {
    if (!submitButton) return null;
    var children = submitButton.children;
    for (var i = 0; i < children.length; i++) {
      if (children[i].tagName === 'SPAN') return children[i];
    }
    return null;
  }

  function bindVariantChangeReblock(productForm, callback) {
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
    subscribe(PUB_SUB_EVENTS.variantChange, function(event) {
      var sectionId = productForm.dataset.sectionId;
      if (sectionId && event.data.sectionId !== sectionId) return;
      callback();
    });
  }

  function findFcBlockedTargets(sectionId) {
    if (!sectionId) return [];
    return [
      document.getElementById('Quantity-Form-' + sectionId),
      document.getElementById('variant-selects-' + sectionId)
    ].filter(Boolean);
  }

  class SalePeriodProductGate {
    constructor() {
      this.productForm = document.querySelector('product-form[data-sale-gate="true"]');
      if (!this.productForm) return;

      this.submitButton = this.productForm.querySelector('[data-sale-gate-button="true"]');
      this.gateMessage = this.productForm.querySelector('.sale-gate-message');
      this.boundPreventSubmit = this.preventSubmit.bind(this);

      this.blockAccess();
      bindVariantChangeReblock(this.productForm, this.blockAccess.bind(this));
    }

    blockAccess() {
      if (this.submitButton) {
        var labelSpan = getSubmitLabelSpan(this.submitButton);
        if (labelSpan) {
          labelSpan.textContent = this.productForm.dataset.saleGateLabel
            || (window.variantStrings && window.variantStrings.beforeSale)
            || '販売開始前';
        }

        this.submitButton.setAttribute('data-sale-gate-blocked', 'true');
        this.submitButton.setAttribute('disabled', 'disabled');
        this.submitButton.setAttribute('aria-disabled', 'true');
      }

      var variantIdInput = this.productForm.querySelector('.product-variant-id');
      if (variantIdInput) {
        variantIdInput.setAttribute('disabled', 'disabled');
      }

      var form = this.productForm.querySelector('form');
      if (form) {
        form.addEventListener('submit', this.boundPreventSubmit, true);
      }

      if (this.gateMessage) {
        this.gateMessage.style.display = 'block';
      }
    }

    preventSubmit(e) {
      if (this.submitButton && this.submitButton.hasAttribute('data-sale-gate-blocked')) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        return false;
      }
    }
  }

  class FCProductGate {
    constructor() {
      this.productForm = document.querySelector('product-form[data-fc-only="true"]');
      if (!this.productForm) return;

      this.submitButton = this.productForm.querySelector('[data-fc-gate="true"]');
      this.gateMessage = this.productForm.querySelector('.fc-gate-message:not(.sale-gate-message)');
      this.fcSiteLink = this.productForm.querySelector('.fc-gate-site-link');
      this.promoBanner = this.productForm.querySelector('.fc-promo-banner');

      this.fcReferrerDomain = this.productForm.dataset.fcReferrerDomain || 'https://matsuri-fc.com/';
      this.fcMemberParamName = this.productForm.dataset.fcMemberParamName || 'fcmember';
      this.fcMemberParamValue = this.productForm.dataset.fcMemberParamValue || 'xzuyf2w4m9';
      this.allowTtlMinutes = parseInt(this.productForm.dataset.allowTtlMinutes || '1440', 10);

      this.blockedTargets = findFcBlockedTargets(this.productForm.dataset.sectionId);

      this.storageKey = STORAGE_KEY;
      this.boundPreventSubmit = this.preventSubmit.bind(this);

      this.init();
      bindVariantChangeReblock(this.productForm, this.onVariantChange.bind(this));
    }

    init() {
      const isAllowed = this.checkAccess();

      if (isAllowed) {
        this.allowAccess();
        this.saveAllowedState();
      } else {
        this.blockAccess();
      }
    }

    onVariantChange() {
      if (this.checkAccess()) {
        this.allowAccess();
        this.saveAllowedState();
      } else {
        this.blockAccess();
      }
    }

    checkAccess() {
      if (this.isAllowedFromStorage()) {
        return true;
      }

      if (this.checkReferrer() && this.checkUrlParam()) {
        return true;
      }

      return false;
    }

    isAllowedFromStorage() {
      try {
        const stored = localStorage.getItem(this.storageKey);
        if (!stored) return false;

        const data = JSON.parse(stored);
        const now = Date.now();

        if (now - data.timestamp < this.allowTtlMinutes * 60 * 1000) {
          return true;
        } else {
          localStorage.removeItem(this.storageKey);
          return false;
        }
      } catch (e) {
        console.error('[fc-gate]', e);
        return false;
      }
    }

    checkReferrer() {
      const referrer = document.referrer;
      if (!referrer) return false;

      return referrer.startsWith(this.fcReferrerDomain);
    }

    checkUrlParam() {
      return checkUrlParam(this.fcMemberParamName, this.fcMemberParamValue);
    }

    saveAllowedState() {
      try {
        const data = {
          timestamp: Date.now(),
          ttlMinutes: this.allowTtlMinutes
        };
        localStorage.setItem(this.storageKey, JSON.stringify(data));
      } catch (e) {
        console.error('[fc-gate]', e);
      }
    }

    restoreSubmitLabelIfNeeded() {
      if (!this.submitButton) return;
      var backup = this.submitButton.getAttribute('data-fc-label-backup');
      if (backup == null) return;
      var labelSpan = getSubmitLabelSpan(this.submitButton);
      if (labelSpan) {
        labelSpan.textContent = backup;
      }
      this.submitButton.removeAttribute('data-fc-label-backup');
    }

    setBlockedTargetsVisible(visible) {
      this.blockedTargets.forEach(function(target) {
        if (visible) {
          target.classList.add('fc-gate-blocked-target--visible');
        } else {
          target.classList.remove('fc-gate-blocked-target--visible');
        }
      });
    }

    allowAccess() {
      if (this.submitButton) {
        this.submitButton.style.display = '';
        this.submitButton.removeAttribute('data-fc-blocked');

        this.restoreSubmitLabelIfNeeded();

        const variantIdInput = this.productForm.querySelector('.product-variant-id');
        const isVariantAvailable = variantIdInput && !variantIdInput.hasAttribute('disabled');

        if (isVariantAvailable) {
          this.submitButton.removeAttribute('disabled');
          this.submitButton.removeAttribute('aria-disabled');
        }
      }

      if (this.fcSiteLink) {
        this.fcSiteLink.style.display = 'none';
      }

      if (this.productForm) {
        const form = this.productForm.querySelector('form');
        if (form) {
          form.removeEventListener('submit', this.boundPreventSubmit, true);
        }
      }

      if (this.gateMessage) {
        this.gateMessage.style.display = 'none';
      }

      if (this.promoBanner) {
        this.promoBanner.style.display = 'none';
      }

      this.setBlockedTargetsVisible(true);
    }

    blockAccess() {
      if (this.submitButton) {
        this.submitButton.style.display = 'none';
        this.submitButton.setAttribute('data-fc-blocked', 'true');
        this.submitButton.setAttribute('disabled', 'disabled');
        this.submitButton.setAttribute('aria-disabled', 'true');
      }

      if (this.fcSiteLink) {
        this.fcSiteLink.style.display = '';
      }

      if (this.productForm) {
        const form = this.productForm.querySelector('form');
        if (form) {
          form.addEventListener('submit', this.boundPreventSubmit, true);
        }
      }

      if (this.gateMessage) {
        this.gateMessage.style.display = 'block';
      }

      if (this.promoBanner) {
        this.promoBanner.style.display = '';
      }

      this.setBlockedTargetsVisible(false);
    }

    preventSubmit(e) {
      if (this.submitButton && this.submitButton.hasAttribute('data-fc-blocked')) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        return false;
      }
    }
  }

  function init() {
    runGlobalAllowCheck();
    if (document.querySelector('product-form[data-sale-gate="true"]')) {
      new SalePeriodProductGate();
    } else if (document.querySelector('product-form[data-fc-only="true"]')) {
      new FCProductGate();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
